<template>
  <div class="hero-homepage__gallery">
    <div class="hero-homepage__gallery--wrapper">
      <div class="hero-homepage__gallery--wrapper-slide"
           :data-index="index"
           v-for="(item, index) in items"
           :key="index"
           v-show="index === activeIndex"
           :class="index === activeIndex && 'hero-homepage__gallery--wrapper-slide-active'"
           v-touch:swipe.right="previousSlide"
           v-touch:swipe.left="nextSlide"
      >
        <hero-homepage-picture
          :active="index === activeIndex"
          :translations="translations"
          :desktop-sizes="desktopSizes"
          :item="item"
          :mobile-sizes="mobileSizes"
          :is-mobile="isSmallDevice"
          :main="index === 0"
          :initial-load="initialLoad"
        />
        <div class="hero-homepage__container">
          <hero-homepage-content
            :cta-link-class="item.cta_link_class"
            :item="item"
            :index="index"
          />
        </div>
      </div>
    </div>
    <div class="hero-homepage__gallery--controls">
      <div class="hero-homepage__gallery--controls-button hero-homepage__gallery--controls-button-prev" v-show="showNavigationButtons" tabindex="0"
           @click="previousSlide"
           @keydown.enter.prevent="previousSlide"
           @keydown.space.prevent="previousSlide">
        <hero-homepage-arrow direction="left"/>
      </div>
      <div class="hero-homepage__gallery--controls-pagination" v-show="showNavigationButtons">
        <button
          class="hero-homepage__gallery--pagination-bullet"
          v-for="(item, index) in items"
          :key="index"
          :class="index === activeIndex ? 'hero-homepage__gallery--pagination-bullet-active' : ''"
          @click="selectSlide(index)"
          :aria-label="'Skip to slide ' + (index + 1)"
          role="button"
        >
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="hero-homepage__gallery--controls-button hero-homepage__gallery--controls-button-next" v-show="showNavigationButtons" tabindex="0" @click="nextSlide" @keydown.enter.prevent="nextSlide"
           @keydown.space.prevent="nextSlide">
        <hero-homepage-arrow direction="right"/>
      </div>
    </div>
  </div>
</template>

<script>
import {isMobile, isSmallDevice} from "Assets/js/components/size-checker";
import HeroHomepagePicture from "./heroHomepagePicture.vue";
import HeroHomepageContent from "./heroHomepageContent.vue";
import HeroHomepageArrow from "./heroHomepageArrow.vue";

export default {
  name: "heroHomepageGalleryV2",
  components: {
    HeroHomepagePicture,
    HeroHomepageContent,
    HeroHomepageArrow,
  },
  props: {
    desktopSizes: String,
    translations: Object,
    items: Array,
    mobileSizes: String,
    autoplay: Boolean,
  },
  emits: ["finalise", "update"],
  data() {
    return {
      activeIndex: 0, // Default: load immediately first image
      isMobile: isMobile(),
      isSmallDevice: isSmallDevice(),
      resizeTimeout: null, // Used by resize() method to limit refreshes
      resizeInterval: 100, // Timeout in milliseconds. Used by resize() method to limit refreshes
      initialLoad: true, // Initial load flag, to avoid fadeIn effect for first picture
      autoplayTimeout: null,
      autoplayInterval: 5000,
    }
  },
  beforeMount() {
    // Add resize listener
    this._boundedResize = this.resize.bind(this); // Store in a var in order to remove it later
    window.addEventListener("resize", this._boundedResize);
    this.autoplayInit();
  },
  mounted() {
    this.$emit('finalise');
  },
  destroyed() {
    clearTimeout(this.autoplayTimeout);
    // Remove resize listener
    window.removeEventListener("resize", this._boundedResize);
  },
  computed: {
    css() {
      return 'hero-homepage__gallery';
    },
    showNavigationButtons() {
      return this.items && this.items.length > 1;
    },
  },
  methods: {
    /**
     * Previous slide
     */
    previousSlide() {
      this.initialLoad = false;
      this.activeIndex = this.activeIndex > 0 ? this.activeIndex - 1 : this.items.length - 1;
      this.$emit('update', this.activeIndex);
      this.autoplayInit();
    },

    /**
     * Next slide
     */
    nextSlide() {
      this.initialLoad = false;
      this.activeIndex = this.activeIndex + 1 < this.items.length ? this.activeIndex + 1 : 0;
      this.$emit('update', this.activeIndex);
      this.autoplayInit();
    },

    selectSlide(index) {
      this.initialLoad = false;
      this.activeIndex = index;
      this.$emit('update', this.activeIndex);
      this.autoplayInit();
    },

    /**
     * Resize callback, called by timeout set in resize() method
     */
    resizeCallback() {
      // Update flags
      this.isMobile = isMobile();
      this.isSmallDevice = isSmallDevice();
    },

    /**
     * Handler for window.resize event. Using a timeout will limit refreshes during resize time.
     */
    resize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(this.resizeCallback, this.resizeInterval);
    },

    autoplayCallback() {

      if (this.autoplay && this.items?.length > 1) {

        this.autoplayInterval = 5000;

        if( this.isMobile && this.items[this.activeIndex]['phone_mp4_video'] ) {
          this.autoplayInterval = this.items[this.activeIndex]['phone_mp4_video']['length'];
        }

        if( !this.isMobile && this.items[this.activeIndex]['desktop_mp4_video'] ) {
          this.autoplayInterval = this.items[this.activeIndex]['desktop_mp4_video']['length'];
        }

        this.nextSlide();
      }
    },

    autoplayInit() {
      if (this.autoplay) {
        clearTimeout(this.autoplayTimeout);

        this.autoplayInterval = 5000;

        if( this.isMobile && this.items[this.activeIndex]['phone_mp4_video'] ) {
          this.autoplayInterval = this.items[this.activeIndex]['phone_mp4_video']['length'];
        }

        if( !this.isMobile && this.items[this.activeIndex]['desktop_mp4_video'] ) {
          this.autoplayInterval = this.items[this.activeIndex]['desktop_mp4_video']['length'];
        }

        this.autoplayTimeout = setTimeout(this.autoplayCallback, this.autoplayInterval);
      }
    }
  }
};
</script>
